import { Switch as AntdSwitch } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import styled, { css } from 'styled-components';

import { colors } from '../../styles/colors/';

const PRIMARY_COLOR_SHADE = {
  color: 'indigo',
  default: 6,
};

const TOGGLE_OFF_SHADE = {
  color: 'gray',
  default: 4,
};

const StyledOuterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledLabel = styled.span`
  margin-left: 8px;
  line-height: 24px !important;
  font-size: ${(props) => (props.size === 'small' ? '14px' : '16px')};
`;

const SwitchContainer = styled.div`
  display: flex; // to properly center align antd switch on row

  .ant-switch {
    ${(props) => css`
      background: ${(props) =>
        colors[props.toggleOffShade['color']][props.toggleOffShade['default']]};
    `};
  }
  .ant-switch-checked {
    ${(props) => css`
      background: ${(props) =>
        colors[props.colorAndShade['color']][props.colorAndShade['default']]};
    `};
  }
`;

/**
 * Primary UI component for user interaction
 */
const Switch = ({
  label,
  loading,
  disabled,
  size,
  checked,
  defaultChecked,
  onChange,
  ...props
}) => {
  let toggleOffShade = TOGGLE_OFF_SHADE;
  let colorAndShade = PRIMARY_COLOR_SHADE;
  return (
    <React.Fragment>
      <StyledOuterContainer>
        <SwitchContainer toggleOffShade={toggleOffShade} colorAndShade={colorAndShade}>
          <AntdSwitch
            label={label}
            loading={loading}
            disabled={disabled}
            size={size}
            checked={checked}
            defaultChecked={defaultChecked}
            onChange={onChange}
            {...props}
          />
        </SwitchContainer>
        <StyledLabel size={size}>{label}</StyledLabel>
      </StyledOuterContainer>
    </React.Fragment>
  );
};

Switch.propTypes = {
  /**
   * Button contents
   */
  label: PropTypes.string,

  loading: PropTypes.bool,

  disabled: PropTypes.bool,

  checked: PropTypes.bool,

  defaultChecked: PropTypes.bool,

  size: PropTypes.oneOf(['small', 'default']),
};

Switch.defaultProps = {
  loading: false,
  size: 'default',
  disabled: false,
};

export { Switch };
